<template>
	<div class="header">
		<!-- 折叠按钮 -->
		<div class="collapse-btn" @click="collapseChage">
			<i v-if="!collapse" class="el-icon-s-fold"></i>
			<i v-else class="el-icon-s-unfold"></i>
		</div>
		<div class="logo">FCS管理系统</div>
		<div class="header-right">
			<div class="header-user-con">
				<!-- 消息中心 -->
				<!-- <div class="btn-bell">
					<el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">
						<router-link to="/Plan">
							<i class="el-icon-bell"></i>
						</router-link>
					</el-tooltip>
					<span class="btn-bell-badge" v-if="message"></span>
				</div> -->
				<!-- 用户头像 -->
				<div class="user-avator">
					<!-- <img v-if="role==1" src="../assets/img/img.jpg" />
					<img v-else-if="role==2" src="../assets/img/img1.jpg" />
					<img v-else src="../assets/img/img2.jpg" /> -->
					<!-- <img :src="src" /> -->
				</div>
				<!-- 用户名下拉菜单 -->
				<el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
						{{username}}
						<i class="el-icon-caret-bottom"></i>
					</span>
					<template #dropdown>
						<el-dropdown-menu>
							<!-- <a href="https://github.com/lin-xin/vue-manage-system" target="_blank">
                                <el-dropdown-item>项目仓库</el-dropdown-item>
                            </a> -->
							<el-dropdown-item divided command="return">修改密码</el-dropdown-item>
							<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</div>
		</div>
		<el-dialog title="修改密码" v-model="editVisible" width="20%">
			<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
				<el-form-item label="原密码" prop="oldPassword">
					<el-input v-model="ruleForm.oldPassword" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="ruleForm.newPassword" show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input v-model="ruleForm.confirmPassword" show-password></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="editVisible = false">取 消</el-button>
					<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				rules: {
					newPassword: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],


					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}, {
						required: true,
						validator: this.bargainIdcard,
						trigger: "chang"
					}],

					confirmPassword: [{
							required: true,
							message: '请确认密码',
							trigger: 'blur'
						},
						{
							required: true,
							validator: this.confirmPassword,
							trigger: "chang"
						}
					],
				},
				ruleForm: {
					oldPassword: '',
					newPassword: '',
					confirmPassword:''
				},
				editVisible: false,
				fullscreen: false,
				name: "",
				message: 2,
				role: localStorage.getItem("role"),
				Id: localStorage.getItem('Id'),
				token: localStorage.getItem('access_token')
			};
		},
		computed: {
			username() {
				let username = localStorage.getItem("ms_username");
				return username ? username : this.name;
			},
			collapse() {
				return this.$store.state.collapse;
			}
		},
		methods: {

			confirmPassword(rule, value, callback) {
				if (this.ruleForm.newPassword == this.ruleForm.confirmPassword) {
					callback()
				} else {
					callback(new Error("两次密码输入不一致!"))
				}
			},
			bargainIdcard(rule, value, callback) {
				var token = this.token;
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + this.Id,
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					console.log(res.data.Data.PassWord)
					if (this.ruleForm.oldPassword == res.data.Data.PassWord) {
						callback()
					} else {
						callback(new Error("原密码错误!"))
					}
				})
			},
			saveEdit(ruleForm) {
				this.$refs[ruleForm].validate((valid) => {
					if (valid) {
						axios({
							method: 'post',
							url: this.$store.state.url + "UpdatePassword?userId=" + this.Id +
								'&password=' + this.ruleForm.newPassword,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								this.$message({
									type: 'success',
									message: '修改成功！你的新密码: ' + this.ruleForm.newPassword
								});
								this.editVisible = false
							} else {
								this.$message.error('修改密码失败!')
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 用户名下拉菜单选择事件
			handleCommand(command) {
				if (command == "loginout") {
					// localStorage.removeItem("ms_username");
					// localStorage.removeItem("RoleId");
					localStorage.clear()
					this.$router.push("/login");
				}
				if (command == "return") {
					this.editVisible = true
					this.ruleForm.oldPassword = ''
					this.ruleForm.newPassword = ''
					this.ruleForm.confirmPassword = ''
					// this.$prompt('请输入新密码', '修改密码', {
					// 	confirmButtonText: '确定',
					// 	cancelButtonText: '取消',
					// 	// inputType:'password' + 'show-password'
					// }).then(({
					// 	value
					// }) => {

					// 	axios({
					// 		method: 'post',
					// 		url: this.$store.state.url + "UpdatePassword?userId=" + this.Id +
					// 			'&password=' + value,
					// 		headers: {
					// 			"Authorization": "bearer " + this.token
					// 		},
					// 	}).then((res) => {
					// 		if (res.data.Message == '请求成功') {
					// 			this.$message({
					// 				type: 'success',
					// 				message: '修改成功！你的新密码: ' + value
					// 			});
					// 			localStorage.clear()
					// 			this.$router.push("/login");
					// 		} else {
					// 			this.$message.error('修改密码失败!')
					// 		}
					// 	})

					// }).catch(() => {
					// 	this.$message({
					// 		type: 'info',
					// 		message: '取消修改'
					// 	});
					// });

				}
			},
			// 侧边栏折叠
			collapseChage() {
				this.$store.commit("hadndleCollapse", !this.collapse);
			}
		},
		mounted() {
			if (document.body.clientWidth < 1500) {
				this.collapseChage();
			}
		}
	};
</script>
<style scoped>
	.header {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		height: 70px;
		font-size: 22px;
		color: #fff;
	}

	.collapse-btn {
		float: left;
		padding: 0 21px;
		cursor: pointer;
		line-height: 70px;
	}

	.header .logo {
		float: left;
		width: 250px;
		line-height: 70px;
	}

	.header-right {
		float: right;
		padding-right: 50px;
	}

	.header-user-con {
		display: flex;
		height: 70px;
		align-items: center;
	}

	.btn-fullscreen {
		transform: rotate(45deg);
		margin-right: 5px;
		font-size: 24px;
	}

	.btn-bell,
	.btn-fullscreen {
		position: relative;
		width: 30px;
		height: 30px;
		text-align: center;
		border-radius: 15px;
		cursor: pointer;
	}

	.btn-bell-badge {
		position: absolute;
		right: 0;
		top: -2px;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #f56c6c;
		color: #fff;
	}

	.btn-bell .el-icon-bell {
		color: #fff;
	}

	.user-name {
		margin-left: 10px;
	}

	.user-avator {
		margin-left: 20px;
	}

	.user-avator img {
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}

	.el-dropdown-link {
		color: #fff;
		cursor: pointer;
	}

	.el-dropdown-menu__item {
		text-align: center;
	}
</style>
